var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 8.66732C3.70283 8.66732 4.0013 8.36884 4.0013 8.00065C4.0013 7.63246 3.70283 7.33398 3.33464 7.33398C2.96645 7.33398 2.66797 7.63246 2.66797 8.00065C2.66797 8.36884 2.96645 8.66732 3.33464 8.66732Z",
    stroke: "#232633",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 8.66732C8.36689 8.66732 8.66536 8.36884 8.66536 8.00065C8.66536 7.63246 8.36689 7.33398 7.9987 7.33398C7.63051 7.33398 7.33203 7.63246 7.33203 8.00065C7.33203 8.36884 7.63051 8.66732 7.9987 8.66732Z",
    stroke: "#232633",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8.66732C13.0349 8.66732 13.3333 8.36884 13.3333 8.00065C13.3333 7.63246 13.0349 7.33398 12.6667 7.33398C12.2985 7.33398 12 7.63246 12 8.00065C12 8.36884 12.2985 8.66732 12.6667 8.66732Z",
    stroke: "#232633",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsBlack);
export default __webpack_public_path__ + "static/media/options-black.1e4076808ec38563146af1aa85f4a6ff.svg";
export { ForwardRef as ReactComponent };